import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.whiteish,
  fontColor: colors.onyx,
  textColorDark: colors.onyx,
  textColorLight: colors.white
};
export default promoBanner;